
import {Component, Input} from '@angular/core';
import {ProductGroupEntity} from '@em/data-feed/util-types';
import {TranslateModule} from '@ngx-translate/core';
import {EmProductGroupCardComponent} from '../product-group-card/product-group-card.component';

@Component({
  selector: 'em-product-groups-list',
  imports: [TranslateModule, EmProductGroupCardComponent],
  templateUrl: './product-groups-list.component.html',
  styleUrls: ['./product-groups-list.component.scss'],
})
export class EmProductGroupsListComponent {
  @Input() groups: ProductGroupEntity[] | undefined | null;
  @Input() allowAddNew = true;
  @Input() allowDelete = true;
  @Input() compactView = false;

  trackByUuid(index: number, group: ProductGroupEntity) {
    return group.uuid;
  }
}
